import React, { useEffect, useRef, useState } from 'react';
import { Card, Button } from 'tea-component';
import { connect } from 'umi';
import ShowSql from './ShowSql';
import Operating from './Operating';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { namespace } from '@/pages/aigc/pages/Text2SQL/model';
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import './index.scss';
import _ from 'lodash-es';
import { useUpdate } from 'ahooks';

function SqlResult(props) {
  const { relevantTables, sqlInfo, dispatch, chatLoading, messages } = props;
  const { formatMessage: text2sqlFormat, isEn } = useAigcIntl('text2sql');

  const [visible, setVisible] = useState(false);
  const updata = useUpdate();
  const refCloneDeep = useRef('');
  let showRebuildBtn = !!sqlInfo || !!refCloneDeep.current;
  useEffect(() => {
    (sqlInfo || !_.isEmpty(refCloneDeep.current)) && setVisible(true);
  }, [JSON.stringify(relevantTables),]);

  useEffect(() => {
    if (!_.isEmpty(sqlInfo)) {
      refCloneDeep.current = sqlInfo;
    }
    else {
      refCloneDeep.current = '';
    }
  }, [sqlInfo]);
  useEffect(() => {
    if (messages.length === 1) {
      updata();
      showRebuildBtn = false;
      refCloneDeep.current = '';
    }
  }, [messages.length, updata]);

  return (
    <Card className={'sql-result-card'}>
      <Card.Body
        title={text2sqlFormat(relevantTables ? 'sql_result_title' : 'sql_title')}
        operation={
          showRebuildBtn ? (
            <div className={'rebuild-sql'}>
              <div className={`rebuild-sql-bubble ${visible ? 'bubble-visible' : ''}`}>
                <SvgIcon type={'exclamation-mark'} />
                {text2sqlFormat('sql_change')}
              </div>

              <Button
                type="link"
                disabled={chatLoading}
                onClick={() => {
                  setVisible(false);
                  dispatch({
                    type: `${namespace}/rebuildTableOrSql`,
                    payload: {
                      message: text2sqlFormat('sql_rebuild'),
                      isEn,
                    },
                  });
                }}
              >
                {text2sqlFormat('sql_rebuild')}
              </Button>
            </div>
          ) : (
            ''
          )
        }
      >
        {(!relevantTables) && (!sqlInfo) ? <Operating /> : <ShowSql text2sqlFormat={text2sqlFormat} refCloneDeep={refCloneDeep.current} isEn={isEn} {...props} />}
      </Card.Body>
    </Card>
  );
}

export default connect((state) => {
  const { relevantTables, sqlInfo, chatError, chatLoading, currentGame, messages } = state[namespace];
  return {
    sqlInfo,
    relevantTables,
    chatError,
    chatLoading,
    gameCode: currentGame?.game_code,
    messages
  };
})(SqlResult);
